export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return 'Não informado';
  const date = new Date(dateString);
  try {
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  } catch (error) {
    return '';
  }
};
